import React, { useEffect } from 'react';
import FullLayout2 from '../asyncIntake/screens/components/FullLayout';
import styled from 'styled-components';
import { Flex, Heading, Text } from 'rebass';
import { AsyncPostRegisterInner } from '../asyncRegister/AsyncPostRegister';
import withAnalytics, { _getConsentState } from '../../lib/withAnalytics';
import { uuidv4 } from '../../utils/uuid';

const PageContainer = styled(Flex)`
  flex: 1;
  flex-direction: row;
  min-height: 100vh;
  min-width: 100vw;
  @media screen and (max-width: 1000px) {
    flex-direction: column;
  }
`;

const LogoContainer = styled(Flex)`
  flex: 1;
  flex-direction: column;
  background: linear-gradient(180deg, rgba(246, 162, 147, 0.4) 0%, rgba(246, 162, 147, 0.4) 44.49%, rgba(217, 74, 106, 0.4) 100%);
  align-items: center;
  padding-top: 101px;
  padding-left: 16px;
  padding-right: 16px;
  .title {
    font-size: 40px;
    max-width: min(535px, 80vw);
    margin-top: 32px;
    margin-bottom: 32px;
  }
  .titleMobile {
    display: none;
  }

  .description {
    font-size: 15px;
    font-weight: 300;
    max-width: min(535px, 40vw);
  }
  @media screen and (max-width: 1000px) {
    padding-top: 20px;
    flex: initial;
    padding-bottom: 20px;
    align-items: center;
    .title {
      display: none;
    }
    .titleMobile {
      display: initial;
      font-size: 30px;
      max-width: min(535px, 80vw);
      margin-top: 16px;
      margin-bottom: 16px;
    }

    .description {
      font-size: 14px;
      font-weight: 300;
      max-width: min(630px, 80vw);
      display: none;
    }
    svg {
      height: 60px;
      width: 60px;
    }
  }
`;

const ScreensContainer = styled(Flex)`
  flex: 1;
  flex-direction: column;
  justify-content: center;
  padding-top: 30px;
  padding-left: 46px;
  padding-right: 16px;
  align-items: flex-start;
  .title {
    font-size: 30px;
    margin-bottom: 16px;
    text-align: left;
  }
  .description {
    max-width: 628px;
    text-align: left;
    margin-bottom: 60px;
    font-size: 17px;
    font-weight: 300;
  }

  @media screen and (max-width: 1000px) {
    padding-top: 20px;
    padding-left: 16px;
    align-items: center;
    .title {
      font-size: 24px;
      margin-bottom: 16px;
      text-align: center;
      display: none;
    }
    .description {
      max-width: 90%;
      text-align: left;
      margin-bottom: 40px;
      font-size: 15px;
      font-weight: 500;
      text-align: center;
    }
  }
`;

export const SubscribedSuccess = withAnalytics((props) => {
  useEffect(() => {
    props.analytics.page();
        
    if (!consents || !consents.marketing) return;
    const price = props.match && props.match.params && props.match.params.id?props.match.params.id:null
    const iframe = document.createElement('iframe');
    const consents = _getConsentState();
    iframe.src = '/meta-purchase-frame.html';
    iframe.style.display = 'none';
    iframe.onload = () => {
      iframe.contentWindow.postMessage(
        {
          type: 'META_PURCHASE',
          eventId: uuidv4(),
          value: price,
          currency: 'USD',
        },
        window.location.origin,
      );
    };

    document.body.appendChild(iframe);

    return () => {
      try {
        iframe.remove()
      } catch (error) {}
    };
  }, []);
  return (
    <PageContainer>
      <LogoContainer>
        <svg width="94" height="94" viewBox="0 0 94 94" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="47" cy="47" r="47" fill="#EAFFF9" fillOpacity="0.59" />
          <ellipse cx="49" cy="50" rx="17" ry="14" fill="#344F7A" />
          <mask id="mask0_264_193" maskUnits="userSpaceOnUse" x="24" y="25" width="47" height="47">
            <path
              d="M47.4999 70.5827C50.4004 70.5863 53.2731 70.0167 55.9528 68.9067C58.6326 67.7966 61.0666 66.1681 63.115 64.1145C65.1686 62.0661 66.7971 59.6321 67.9072 56.9523C69.0172 54.2726 69.5868 51.3999 69.5832 48.4994C69.5868 45.5988 69.0172 42.7262 67.9072 40.0464C66.7971 37.3667 65.1686 34.9327 63.115 32.8842C61.0666 30.8307 58.6326 29.2021 55.9528 28.0921C53.2731 26.982 50.4004 26.4125 47.4999 26.416C44.5993 26.4125 41.7266 26.982 39.0469 28.0921C36.3672 29.2021 33.9331 30.8307 31.8847 32.8842C29.8312 34.9327 28.2026 37.3667 27.0926 40.0464C25.9825 42.7262 25.4129 45.5988 25.4165 48.4994C25.4129 51.3999 25.9825 54.2726 27.0926 56.9523C28.2026 59.6321 29.8312 62.0661 31.8847 64.1145C33.9331 66.1681 36.3672 67.7966 39.0469 68.9067C41.7266 70.0167 44.5993 70.5863 47.4999 70.5827Z"
              fill="white"
              stroke="white"
              strokeWidth="2"
              strokeLinejoin="round"
            />
            <path d="M38.6665 48.5L45.2915 55.125L58.5415 41.875" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          </mask>
          <g mask="url(#mask0_264_193)">
            <path d="M21 22H74V75H21V22Z" fill="#CFFEE6" />
          </g>
        </svg>

        <Heading className="title" style={{ textAlign: 'center' }}>
          Welcome to Paloma Health!
        </Heading>
        <Heading className="titleMobile" style={{ textAlign: 'center' }}>
          A Healthier You Starts Here!
        </Heading>
        <Text className="description" style={{ textAlign: 'center' }}>
          Your journey to better thyroid and hormonal health starts here.
        </Text>
      </LogoContainer>
      <ScreensContainer>
        <Heading className="title" mb={4}>
          Start feeling better today
        </Heading>
        <Text className="description">As a Paloma Health member, you have access to a comprehensive suite of services designed to support your thyroid health:</Text>

        <AsyncPostRegisterInner forceNutritionistDescription={'Personalized 30-minute visit'} />
      </ScreensContainer>
    </PageContainer>
  );
});
